import * as fromDatatype from '../datatype-library/index';

export interface bl_fi_my_einvoice_gen_doc_to_irb_submission_history_RowInterface {
  guid: fromDatatype.GuidDataFieldInterface;
  txn_type: fromDatatype.VarcharDatatypeInterface;
  generic_doc_hdr_guid: fromDatatype.GuidDataFieldInterface;
  generic_doc_line_guid: fromDatatype.GuidDataFieldInterface;
  generic_doc_hdr_server_doc_type: fromDatatype.VarcharDatatypeInterface;
  generic_doc_line_server_doc_type: fromDatatype.VarcharDatatypeInterface;
  to_irb_hdr_guid: fromDatatype.GuidDataFieldInterface;
  created_date: fromDatatype.TimestampTzDatatypeInterface;
  updated_date: fromDatatype.TimestampTzDatatypeInterface;
  created_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  created_by_name: fromDatatype.VarcharDatatypeInterface;
  updated_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  updated_by_name: fromDatatype.VarcharDatatypeInterface;
  submission_status: fromDatatype.VarcharDatatypeInterface;
  status: fromDatatype.StatusDataFieldInterface;
  submission_request_date: fromDatatype.TimestampTzDatatypeInterface;
  request_url: fromDatatype.VarcharDatatypeInterface;
  request_body: fromDatatype.TextDatatypeInterface;
  request_response: fromDatatype.TextDatatypeInterface;
  request_error: fromDatatype.TextDatatypeInterface;
  property_json: fromDatatype.JsonDatatypeInterface;
  acl_config: fromDatatype.JsonDatatypeInterface;
  acl_policy: fromDatatype.JsonDatatypeInterface;
  revision: fromDatatype.RevisionDataFieldInterface;
  vrsn: fromDatatype.VrsnDataFieldInterface;
  lhdn_submission_guid: fromDatatype.VarcharDatatypeInterface;
  lhdn_document_guid: fromDatatype.VarcharDatatypeInterface;
  server_doc_1: fromDatatype.VarcharDatatypeInterface;
  code_company: fromDatatype.VarcharDatatypeInterface;
  doc_entity_hdr_json: any;
  date_txn: fromDatatype.TimestampTzDatatypeInterface;
  amount_txn: fromDatatype.NumericDatatypeInterface;
  doc_ccy: fromDatatype.VarcharDatatypeInterface;
  doc_reference: fromDatatype.VarcharDatatypeInterface;
  billing_json: any;
  delivery_entity_json: any;
  amount_tax_gst: fromDatatype.NumericDatatypeInterface;
  qr_code: fromDatatype.TextDatatypeInterface;
  validation_url: fromDatatype.TextDatatypeInterface;
  is_consolidated: boolean;
  to_irb_running_no: fromDatatype.VarcharDatatypeInterface;
  einvoice_buyer_entity_hdr_json: any;
  einvoice_supplier_entity_hdr_json: any;
  buyer_address_json: any;
  supplier_address_json: any;
  validation_status: fromDatatype.VarcharDatatypeInterface;
  validation_date_time: fromDatatype.TimestampTzDatatypeInterface;
  cancellation_date_time: fromDatatype.TimestampTzDatatypeInterface;
  einvoice_submission_type: fromDatatype.VarcharDatatypeInterface;
}

export class bl_fi_my_einvoice_gen_doc_to_irb_submission_history_RowClass
  implements bl_fi_my_einvoice_gen_doc_to_irb_submission_history_RowInterface {
    guid: fromDatatype.GuidDataFieldInterface;
    txn_type: fromDatatype.VarcharDatatypeInterface;
    generic_doc_hdr_guid: fromDatatype.GuidDataFieldInterface;
    generic_doc_line_guid: fromDatatype.GuidDataFieldInterface;
    generic_doc_hdr_server_doc_type: fromDatatype.VarcharDatatypeInterface;
    generic_doc_line_server_doc_type: fromDatatype.VarcharDatatypeInterface;
    to_irb_hdr_guid: fromDatatype.GuidDataFieldInterface;
    created_date: fromDatatype.TimestampTzDatatypeInterface;
    updated_date: fromDatatype.TimestampTzDatatypeInterface;
    created_by_subject_guid: fromDatatype.GuidDataFieldInterface;
    created_by_name: fromDatatype.VarcharDatatypeInterface;
    updated_by_subject_guid: fromDatatype.GuidDataFieldInterface;
    updated_by_name: fromDatatype.VarcharDatatypeInterface;
    submission_status: fromDatatype.VarcharDatatypeInterface;
    status: fromDatatype.StatusDataFieldInterface;
    submission_request_date: fromDatatype.TimestampTzDatatypeInterface;
    request_url: fromDatatype.VarcharDatatypeInterface;
    request_body: fromDatatype.TextDatatypeInterface;
    request_response: fromDatatype.TextDatatypeInterface;
    request_error: fromDatatype.TextDatatypeInterface;
    property_json: fromDatatype.JsonDatatypeInterface;
    acl_config: fromDatatype.JsonDatatypeInterface;
    acl_policy: fromDatatype.JsonDatatypeInterface;
    revision: fromDatatype.RevisionDataFieldInterface;
    vrsn: fromDatatype.VrsnDataFieldInterface;
    lhdn_submission_guid: fromDatatype.VarcharDatatypeInterface;
    lhdn_document_guid: fromDatatype.VarcharDatatypeInterface;
    server_doc_1: fromDatatype.VarcharDatatypeInterface;
    code_company: fromDatatype.VarcharDatatypeInterface;
    doc_entity_hdr_json: any;
    date_txn: fromDatatype.TimestampTzDatatypeInterface;
    amount_txn: fromDatatype.NumericDatatypeInterface;
    doc_ccy: fromDatatype.VarcharDatatypeInterface;
    doc_reference: fromDatatype.VarcharDatatypeInterface;
    billing_json: any;
    delivery_entity_json: any;
    amount_tax_gst: fromDatatype.NumericDatatypeInterface;
    qr_code: fromDatatype.TextDatatypeInterface;
    validation_url: fromDatatype.TextDatatypeInterface;
    is_consolidated: boolean;
    to_irb_running_no: fromDatatype.VarcharDatatypeInterface;
    einvoice_buyer_entity_hdr_json: any;
    einvoice_supplier_entity_hdr_json: any;
    buyer_address_json: any;
    supplier_address_json: any;
    validation_status: fromDatatype.VarcharDatatypeInterface;
    validation_date_time: fromDatatype.TimestampTzDatatypeInterface;
    cancellation_date_time: fromDatatype.TimestampTzDatatypeInterface;
    einvoice_submission_type: fromDatatype.VarcharDatatypeInterface;
}
